import {
  requestList_groupBuyItems,
  requestList,
  requestEditInfo_groupBuyItem,
  productInfo_printableSku,
  requestList_groupBuyItems_groupBuyRequests,
  requestList_groupBuyItems_groupBuyRequests_sizeItems,
  requestList_groupBuyItems_printableSku,
  requestList_groupBuyItems_printableSku_sku_skuColorPatterns_colorPattern,
  printableSku_productByPrintableSku
} from '@/groupBuy/queries/types'
export * from '@/groupBuy/queries/types'
export interface RequestModel {
  requesterName: string
  comment: string
  expiredDate?: Date | undefined
}
export type SizeQuantity = {
  name: string
  value: number
}

export type RequestListResponse = requestList
export type RequestItemModel = requestList_groupBuyItems
export type RequestEditInfo = requestEditInfo_groupBuyItem
export type ProductInfoModel = productInfo_printableSku
export type RequestSizeInputItem = requestList_groupBuyItems_groupBuyRequests
export type SizeItem = requestList_groupBuyItems_groupBuyRequests_sizeItems
export type PrintableSku = requestList_groupBuyItems_printableSku
export type PrintingOptionModel = requestList_groupBuyItems_printableSku_sku_skuColorPatterns_colorPattern
export type ProductByPrintableSku = printableSku_productByPrintableSku


export enum PATTERN_VIEWS {
  COLOR,
  EDIT
}
